import { render, staticRenderFns } from "./referansagore.vue?vue&type=template&id=e3b44a5e&scoped=true"
import script from "./referansagore.vue?vue&type=script&lang=js"
export * from "./referansagore.vue?vue&type=script&lang=js"
import style0 from "./referansagore.vue?vue&type=style&index=0&id=e3b44a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b44a5e",
  null
  
)

export default component.exports